'use client'

import { stringToSlug } from '@/lib/utils/common'
import Image from 'next/image'
import Link from 'next/link'
import { useMemo } from 'react'
import { useProductCardContext } from './context/product-card-context'

export const ProductItemRating = () => {
  const { product, selectedColor, trackingClickProduct } =
    useProductCardContext()

  const rating = useMemo(() => {
    const avg = product?.review?.avg
    if (!avg) return null
    return Math.round((avg / 2) * 10) / 10
  }, [product?.review?.avg])

  if (!rating) return null

  const href = `${product.href}${selectedColor ? `?color=${stringToSlug(selectedColor)}` : ''}#product-reviews`

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    trackingClickProduct()
  }

  return (
    <Link
      href={href}
      className='flex shrink-0 items-center gap-0.5 lg:gap-1'
      onClick={handleClick}
      aria-label={`Xem đánh giá sản phẩm ${product?.title}`}
      prefetch={false}
    >
      <Image
        src='/icons/product/icon-star-gold.svg'
        width={12}
        height={12}
        alt='rating'
        className='h-3 w-3 lg:h-4 lg:w-4'
      />
      <span className='font-sans text-xs font-medium leading-3.5 text-neutral-700 lg:text-sm lg:leading-4.5'>
        {rating.toFixed(1)}
      </span>
    </Link>
  )
}
